import { GzWizardWebComponent } from './component/GzWizardWebComponent';
import { GzWizardStepWebComponent } from './component/GzWizardStepWebComponent';

export { GzWizardWebComponent, GzWizardStepWebComponent };
